import React from "react";
import { useFetch } from "@/lib/api";
import { PageHeader, Loading, StatCard, SectionTitle } from "@/components/common";
import { fmtUsd, fmtNum, fmtPct } from "@/lib/format";
import { Activity, Cpu, DollarSign, Rocket, Droplets, Users } from "lucide-react";

export default function MarketOverview() {
  const { data, loading } = useFetch("/market/overview", []);
  if (loading || !data) return <Loading />;
  const m = data.data;

  return (
    <div className="fade-in">
      <PageHeader icon={Activity} title="Market Overview" subtitle="Solana ecosystem vitals & market pulse." />
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4">
        <StatCard label="SOL Price" value={fmtUsd(m.sol_price)} sub={fmtPct(m.sol_change_24h)} tone={m.sol_change_24h >= 0 ? "pos" : "neg"} icon={DollarSign} />
        <StatCard label="Network TPS" value={fmtNum(m.tps)} icon={Cpu} />
        <StatCard label="DEX Volume 24h" value={fmtUsd(m.dex_volume_24h)} icon={Activity} />
        <StatCard label="Tokens / hour" value={m.tokens_created_per_hour} icon={Rocket} />
        <StatCard label="New Pairs 24h" value={fmtNum(m.total_new_pairs_24h)} icon={Rocket} />
        <StatCard label="Graduation Rate" value={`${m.graduation_rate}%`} icon={Rocket} />
        <StatCard label="Avg Liquidity" value={fmtUsd(m.avg_liquidity)} icon={Droplets} />
        <StatCard label="Active Traders" value={fmtNum(m.active_traders)} icon={Users} />
        <StatCard label="New Pairs 1h" value={m.new_pairs_1h} icon={Activity} />
        <StatCard label="New Pairs 15m" value={m.new_pairs_15m} icon={Activity} />
        <StatCard label="New Pairs 5m" value={m.new_pairs_5m} icon={Activity} />
        <StatCard label="Activity Accel" value={fmtPct(m.activity_acceleration)} tone={m.activity_acceleration >= 0 ? "pos" : "neg"} icon={Activity} />
      </div>
      <div className="pnut-card mt-5 p-4">
        <SectionTitle>About these vitals</SectionTitle>
        <p className="text-xs leading-relaxed text-slate-400">
          These metrics summarise the health and velocity of the Solana memecoin market. All values are
          clearly-labeled DEMO data generated for the research sandbox. When live providers (DexScreener,
          Birdeye, Helius, Solana RPC) are connected, these fields populate with real on-chain data through
          the same API contract — no rebuild required.
        </p>
      </div>
    </div>
  );
}
